module.exports = __webpack_public_path__ + "img/contenu_formation.74f6fd79.png";